module.exports = __webpack_public_path__ + "static/img/white_logo.d2559c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/white_logo.png
// module id = cZaH
// module chunks = 23